<template>
	<toolbar>
		<h2><i class="fa fa-users"></i> Employees</h2>

		<div class="controls">

			<slot></slot>
			<!--<router-link v-if="$route.params.tab=='list'" to="/find" class="btn btn-success"><i class="fa fa-plus"></i> New Employee</router-link>

			<search-bar v-if="$route.params.tab == 'list'" placeholder="Search Employees..." v-on:submit="searchUsers"></search-bar>

			<button v-on:click="newClassification" v-else-if="$route.params.tab == 'classifications'" class="btn btn-success"><i class="fa fa-plus"></i> New Classification</button>

			<button v-on:click="newPayBoost" v-else-if="$route.params.tab == 'pay-adjustments'" class="btn btn-success"><i class="fa fa-plus"></i> New Pay Adjustment</button>

			<button v-on:click="newClassificationGroup" v-else-if="$route.params.tab == 'charge-out-groups'" class="btn btn-success"><i class="fa fa-plus"></i> New Charge Out Group</button>-->

			<nav-tabs :tabs="tabs"></nav-tabs>
		</div>
	</toolbar>
</template>
<script type="text/javascript">
import NavTabs from "@/layout_fragments/NavTabs"
import Toolbar from "@/layout_fragments/Toolbar"

export default {
	name: "EmployeesToolbar",
	components: {
		Toolbar,
		NavTabs
	},
	data() {
		return {
			tabs: [
				{
					label: "List",
					icon: "fa-list",
					path: "/employees/list"
				},
				/*{
					label: "Classifications",
					icon: "fa-columns",
					path: "/employees/classifications",
					modulePermRequired: ['Settings','Users']
				},
				{
					label: "Charge Out Groups",
					icon: "fa-columns",
					path: "/employees/charge-out-groups",
					modulePermRequired: ['Settings','Users']
				},
				{
					label: "Pay Adjustments",
					icon: "fa-dollar",
					path: "/employees/pay-adjustments",
					modulePermRequired: ['Settings','Users']
				},*/
				{
					label: "Settings",
					icon: "fa-cog",
					path: "/employees/settings",
					modulePermRequired: ['Settings','Users']
				}
			]
		}
	},
}
</script>